import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Chapter from "@/components/site/Chapter";
import IntroViz from "@/components/site/IntroViz";
import CentralHubViz from "@/components/site/CentralHubViz";
import PrivacyViz from "@/components/site/PrivacyViz";
import PatternViz from "@/components/site/PatternViz";
import PdfViz from "@/components/site/PdfViz";
import OfflineViz from "@/components/site/OfflineViz";
import EditorialMarquee from "@/components/site/EditorialMarquee";
import Zielgruppen from "@/components/site/Zielgruppen";
import FAQ from "@/components/site/FAQ";
import SocialMedia from "@/components/site/SocialMedia";
import Waitlist from "@/components/site/Waitlist";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <main className="relative bg-[#0F172A] text-white overflow-hidden" data-testid="landing-page">
      <Nav />
      <Hero />

      <Chapter
        index="01"
        overline="Was ist BeParent"
        anchor="produkt"
        title={
          <>
            Eine ruhige Software für eine <span className="text-[#00FAF8]">laute</span> Zeit.
          </>
        }
        description="BeParent verwandelt fragmentierte Notizen, WhatsApp-Verläufe und Screenshots in eine strukturierte, verschlüsselte Fallakte. Sachlich, chronologisch, geschützt — und jederzeit exportierbar."
        bullets={[
          "Chronologische Fallakte",
          "Kategorisierte Ereignisse",
          "Verschlüsselte Dokumente",
          "Neutrale Struktur",
        ]}
        visual={<IntroViz />}
      />

      <Chapter
        index="02"
        overline="Alle Informationen an einem Ort"
        anchor="alle-informationen"
        reverse
        title={
          <>
            Alle Informationen. <br />
            <span className="text-white/40">Eine Akte.</span>
          </>
        }
        description="Termine, Kommunikation, Dokumente, Ereignisse und Umgänge fließen über Verbindungslinien in eine zentrale digitale Fallakte — ohne Umwege, übersichtlich gebündelt."
        bullets={[
          "Termine & Umgangszeiten",
          "Kommunikationsverläufe",
          "Dokumente & Berichte",
          "Ereignisse & Notizen",
        ]}
        visual={<CentralHubViz />}
      />

      <Chapter
        index="03"
        overline="Datenschutz"
        anchor="datenschutz"
        title={
          <>
            Ihre Daten. <br />
            Unter <span className="text-[#00FAF8]">Ihrer</span> Kontrolle.
          </>
        }
        description="BeParent verarbeitet Ihre Falldaten nach dem Offline-First-Prinzip. Ihre Dokumentation wird primär auf Ihrem Gerät gespeichert. Optionale Backups werden vor der Übertragung clientseitig verschlüsselt. BeParent erhält keinen Zugriff auf die unverschlüsselten Inhalte Ihrer Fallakte."
        bullets={[
          "Offline First",
          "Clientseitig verschlüsselt",
          "Optionale Backups",
          "Kein Zugriff auf Falldaten",
        ]}
        visual={<PrivacyViz />}
      />

      <EditorialMarquee />

      <Chapter
        index="04"
        overline="Musteranalyse"
        anchor="musteranalyse"
        reverse
        title={
          <>
            Verläufe. <br />
            <span className="text-white/40">Nicht Gefühle.</span>
          </>
        }
        description="Digitale Timeline und stille Diagramme zeigen wiederkehrende Ereignisse, Häufungen und Muster. Die Auswertung ist lokal, kalkulierbar und ohne emotionale Färbung."
        bullets={[
          "Timeline mit Verknüpfungen",
          "Musterkennung on-device",
          "Sortierbar & filterbar",
          "Nur Fakten, keine Deutung",
        ]}
        visual={<PatternViz />}
      />

      <Chapter
        index="05"
        overline="PDF-Export"
        anchor="pdf-export"
        title={
          <>
            Eine Akte. <br />
            <span className="text-[#00FAF8]">Bereit für den Gerichtssaal.</span>
          </>
        }
        description="Auf Knopfdruck exportiert BeParent eine strukturierte, signierte PDF-Fallakte — inklusive Chronologie, Berichten und Prüfsumme. Digital, sauber, überprüfbar."
        bullets={[
          "Strukturierter Bericht",
          "SHA-256 Prüfsumme",
          "Chronologische Kapitel",
          "Optional passwortgeschützt",
        ]}
        visual={<PdfViz />}
      />

      <Chapter
        index="06"
        overline="Offline First"
        anchor="offline"
        reverse
        title={
          <>
            Offline First. <br />
            <span className="text-white/40">Auch ohne dauerhafte Verbindung.</span>
          </>
        }
        description="Nach der Einrichtung und Anmeldung bleibt BeParent für die Arbeit mit Ihrer Fallakte auch ohne Internetverbindung nutzbar. Falldaten werden primär auf Ihrem Gerät verarbeitet und gespeichert. Account- und Falldaten bleiben voneinander getrennt. Optionale Backups werden vor der Übertragung clientseitig verschlüsselt."
        bullets={[
          "Falldaten primär auf dem Gerät",
          "Nach Anmeldung offline nutzbar",
          "Account und Falldaten getrennt",
          "Optionale verschlüsselte Backups",
        ]}
        visual={<OfflineViz />}
      />

      <Zielgruppen />

      <FAQ />

      <SocialMedia />

      <Waitlist />

      <Footer />
    </main>
  );
}
